import { useEffect, useState } from "react";
import {
  Container,
  Paper,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Typography,
  TableContainer,
  Chip,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import api from "../api/axios";
import { useNotify } from "../context/NotificationContext";
const statusColor = (status) => {
  switch (status) {
    case "completed":
      return "success";
    case "cancelled":
      return "error";
    case "new":
    default:
      return "warning";
  }
};

export default function Leads() {
  const { notify } = useNotify();
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    fetchLeads();
  }, []);

  const fetchLeads = () => {
    api.get("/leads").then((res) => setLeads(res.data));
  };

  const updateStatus = async (id, status) => {
    await api.put(`/leads/${id}/status`, { status });
    fetchLeads();
    notify('Status Updated Successfully');
  };

  return (
    <Container maxWidth="xl">
      <Typography variant="h4" fontWeight={600} gutterBottom>
        Vehicle Remap Leads
      </Typography>

      <Paper elevation={3} sx={{ borderRadius: 2 }}>
        <TableContainer>
          <Table>
            <TableHead
              sx={{
                background: "#111827",
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              <TableRow>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Full Name</b>
                </TableCell>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Email</b>
                </TableCell>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Phone</b>
                </TableCell>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Vehicle Type</b>
                </TableCell>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Make</b>
                </TableCell>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Model</b>
                </TableCell>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Fuel</b>
                </TableCell>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Status</b>
                </TableCell>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Update</b>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {leads.length === 0 && (
                <TableRow>
                  <TableCell colSpan={9}>
                    <Box textAlign="center" py={4}>
                      <Typography color="text.secondary">
                        No leads available
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}

              {leads.map((l) => (
                <TableRow key={l.id} hover>
                  <TableCell>{l.full_name}</TableCell>
                  <TableCell>{l.email}</TableCell>
                  <TableCell>{l.phone}</TableCell>
                  <TableCell>{l.vehicle_type}</TableCell>
                  <TableCell>{l.make}</TableCell>
                  <TableCell>{l.model}</TableCell>
                  <TableCell>{l.fuel_type}</TableCell>

                  <TableCell>
                    <Chip
                      label={l.status || "new"}
                      color={statusColor(l.status)}
                      size="small"
                      sx={{ textTransform: "capitalize" }}
                    />
                  </TableCell>

                  <TableCell sx={{ minWidth: 150 }}>
                    <Select
                      size="small"
                      fullWidth
                      value={l.status || "new"}
                      onChange={(e) => updateStatus(l.id, e.target.value)}
                    >
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="completed">Completed</MenuItem>
                      <MenuItem value="cancelled">Cancelled</MenuItem>
                    </Select>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Container>
  );
}
